import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    selectedItem: [],
    selectedColumns: null
  },
  mutations: {
    putSelectedItem (state, payload) {
      state.selectedItem = payload;
    },
    putSelectedColumns (state, payload) {
      state.selectedColumns = payload;
    }
  },
  actions: {
  },
  modules: {
  }
})
